import React from "react";

import { StyledLightBlueBgColor, StyledContainerWrapper, StyledCheckoutVideo, StyledConfSubTitle, StyledConfDesc } from "../styles/StyledEGConf";
import videoImg from "../images/video-img.svg"
import diversity from "../images/diversity.svg"

 const egcVideoState = [
   {
     imgSrc: videoImg,
     title: <a href="/enterprisegraphql/2020/">Check out our videos from EGC’20</a>,
     desc: "In the past we’ve had sponsor booths, exclusive talent acquisition channels, sponsored hackathons and much more. Reach out to our conferences team if you’d like to start a conversation.",
     linkUrl: "#",
   },
   {
     imgSrc: diversity,
     title: "Code of conduct",
     desc: <span>View our code of conduct <a href="/enterprisegraphql/2021/code-of-conduct/">here</a></span>,
   },
 ]
const CheckoutVideo = () => {
  const egcVideo = egcVideoState.map((list, index) => (
    <div key={index} className="videoList">
      <div className="videoImg">
        <img src={list.imgSrc} alt={list.title} />
      </div>
      <StyledConfSubTitle blueColor="#1B2738">{list.title}</StyledConfSubTitle>
      <StyledConfDesc>{list.desc}</StyledConfDesc>
    </div>
  ))
  return (
    <StyledLightBlueBgColor>
      <StyledContainerWrapper>
        <StyledCheckoutVideo>
          { egcVideo }
        </StyledCheckoutVideo>
      </StyledContainerWrapper>
    </StyledLightBlueBgColor>
  );
};

export default CheckoutVideo;
